<template>
  <section class="process" id="how-it-works">
    <div class="process__content container">
      <h1 class="process__uptitle">
        How it works
      </h1>
      <div class="process__content__single">
        <div class="process__content--img">
          <img :src="imageUrl" alt="SMS Text">
        </div>
        <div class="process__content--info">
          <div class="number-circle">1</div>
          <div class="process__text">
            <h2 class="process__title">Targeted SMS Drops</h2>
            <p class="process__description">
              Choose from our Gold, Silver, or Bronze packages to unlock scheduled SMS drops exclusively
              reaching credited investors within our exclusive database. Craft an initial text of up to 112
              characters without emojis to make a compelling introduction.
            </p>
          </div>
        </div>
      </div>
      <div class="process__content__single">
        <div class="process__content--img">
          <img src="../assets/process/landings.png" alt="Landing Pages">
        </div>
        <div class="process__content--info">
          <div class="number-circle">2</div>
          <div class="process__text">
            <h2 class="process__title">Engaging Custom Landing Pages</h2>
            <p class="process__description">
              Upon interaction with the SMS, investors will receive a tailored landing page experience.
              Select between a "Lead Gen" or "Branding" approach, designed to direct them seamlessly to
              the Investor Relations (IR) slide on your website. This strategic setup ensures investors
              are well-primed for potential investment.
            </p>
          </div>
        </div>
      </div>
      <div class="process__content__single">
        <div class="process__content--img">
          <img src="../assets/process/list.png" alt="List of Selected Items">
        </div>
        <div class="process__content--info">
          <div class="number-circle">3</div>
          <div class="process__text">
            <h2 class="process__title">Ongoing List Optimization</h2>
            <p class="process__description">
              We at SRAX are committed to maintaining the relevance of your investor outreach. Continuously,
              we scrub the list to eliminate non-engagers and incorporate new investors, ensuring that each
              future SMS drop is finely tuned for maximum impact.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import mobileImageUrl from '@/assets/process/mobile-sms.png';
import desktopImageUrl from '@/assets/process/sms.png';

export default {
  setup() {
    const imageUrl = ref('');

    const updateImageUrl = () => {
      imageUrl.value = window.innerWidth <= 992 ? mobileImageUrl : desktopImageUrl;
    };

    onMounted(() => {
      updateImageUrl();
      window.addEventListener('resize', updateImageUrl);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateImageUrl);
    });

    return {
      imageUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/components/process.scss";
</style>
